import React from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import Cookie from "js-cookie";
import { API_END_POINT } from "../config";
const token = Cookie.get("waffle_world_access_token");
import { library } from "@fortawesome/fontawesome-svg-core";
import { JWT_SECRET_TOKEN } from "../config";
const jwt = require("jsonwebtoken");
import {
  faUsers,
  faShoppingCart,
  faCloud,
  faExchangeAlt,
  faIcons,
  faDollar,
} from "@fortawesome/free-solid-svg-icons";
library.add(faUsers, faShoppingCart, faCloud, faExchangeAlt, faDollar);
import Metric from "../components/Metric";

import Graph from "../components/Graph";
import "./styles.css";

// import {Pagination} from 'react-bootstrap';
// import LineChart from '../components/LineChart'
// import PieChart from '../components/PieChart'
// import BarChart from '../components/BarChart'
// import Doughnut from '../components/Doughnut'

export default class Area extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      orders: [],
      users: [],
      items: [],
      ordersInDay: [],
      ordersInWeek: [],
      ordersInMonth: [],
      ordersInYear: [],
    };
  }
  componentWillMount() {
    axios
      .get(`${API_END_POINT}/api/orders/`, {
        headers: { "auth-token": token, "x-api-key": JWT_SECRET_TOKEN },
      })
      .then((response) => {
        this.setState({
          orders: response.data.objects,
        });
      })
      .catch((err) => {
        console.log("error fetching data");
      });
    axios
      .get(`${API_END_POINT}/api/users/`, {
        headers: { "auth-token": token, "x-api-key": JWT_SECRET_TOKEN },
      })
      .then((response) => {
        this.setState({
          users: response.data.objects,
        });
      })
      .catch((err) => {
        console.log("error fetching data");
      });
    axios
      .get(`${API_END_POINT}/api/items`, { headers: { "auth-token": token } })
      .then((response) => {
        this.setState({
          items: response.data.objects,
        });
      })
      .catch((err) => {
        console.log("error fetching data");
      });
    axios
      .get(`${API_END_POINT}/api/orders/total/day`, {
        headers: { "auth-token": token },
      })
      .then((response) => {
        this.setState({
          ordersInDay: response.data,
        });
      })
      .catch((err) => {
        console.log("error fetching data");
      });
    axios
      .get(`${API_END_POINT}/api/orders/total/week`, {
        headers: { "auth-token": token },
      })
      .then((response) => {
        this.setState({
          ordersInWeek: response.data,
        });
      })
      .catch((err) => {
        console.log("error fetching data");
      });
    axios
      .get(`${API_END_POINT}/api/orders/total/month`, {
        headers: { "auth-token": token },
      })
      .then((response) => {
        this.setState({
          ordersInMonth: response.data,
        });
      })
      .catch((err) => {
        console.log("error fetching data");
      });
    axios
      .get(`${API_END_POINT}/api/orders/total/year`, {
        headers: { "auth-token": token },
      })
      .then((response) => {
        this.setState({
          ordersInYear: response.data,
        });
      })
      .catch((err) => {
        console.log("error fetching data");
      });
  }

  render() {
    const {
      orders,
      users,
      items,
      ordersInDay,
      ordersInMonth,
      ordersInWeek,
      ordersInYear,
    } = this.state;
    return (
      <div className="row">
        <div className="col-12">
          <div className="section">
            {/* <Graph name="Bestellübersicht" type="timeline" /> */}
          </div>
          <div className="section">
            <div className="half-section">
              {/* <Metric
                value={users.length}
                name="Kunden registriert insgesamt"
                icon="users"
                type="orange"
              /> */}
              <Metric
                value={items.length}
                name="Produkte in der Datenbank"
                icon="shopping-cart"
                type="blue"
              />
            </div>
            <div className="half-section">
              <Metric
                value={orders.length}
                name="Bestellungen insgesamt"
                icon="cloud"
                type="red"
              />
              <Metric
                value={`${ordersInDay.revenue}€`}
                name="Gesamtumsatz heute"
                icon="dollar"
                type="green"
              />
              <Metric
                value={`${ordersInWeek.revenue}€`}
                name="Gesamtumsatz diese Woche"
                icon="dollar"
                type="green"
              />
              <Metric
                value={`${ordersInMonth.revenue}€`}
                name="Gesamtumsatz diese Woche"
                icon="dollar"
                type="green"
              />
              <Metric
                value={`${ordersInYear.revenue}€`}
                name="Gesamtumsatz dieses Jahr"
                icon="dollar"
                type="green"
              />
            </div>
          </div>

          <div className="section">
            {/* <Graph name="Informationen" type="distribution" /> */}

            <Metric
              value={`${ordersInDay.orders}`}
              name="Bestellungen heute"
              icon="shopping-cart"
              type="purple"
            />
            <Metric
              value={`${ordersInWeek.orders}`}
              name="Bestellungen diese Woche"
              icon="shopping-cart"
              type="purple"
            />
            <Metric
              value={`${ordersInMonth.orders}`}
              name="Bestellungen diese Woche"
              icon="shopping-cart"
              type="purple"
            />
            <Metric
              value={`${ordersInYear.orders}`}
              name="Bestellungen dieses Jahr"
              icon="shopping-cart"
              type="purple"
            />

            {/* <ChartOne className="card-summary line-chart" /> */}
            {/* <div className="section">
              <Graph name="Informationen" type="distribution" />
              <Graph name="Monthly Sales" type="timeline" />
            </div> */}
            <div className="col-sm-4"></div>
            <div className="col-sm-4 pull-right mobile-space"></div>
          </div>
          <div className="text-center space-2"></div>
          {/* <div className="row space-1">
            <div className="col-sm-6">
              <h3 className="space-1">Total Users Registered</h3>
              <h5>{users.length ? users.length : "Fetching details..."}</h5>
            </div>
            <div className="col-sm-6 ">
              <h3 className="space-1">Total Orders Received</h3>
              <h5>{orders.length ? orders.length : "Fetching details..."}</h5>
            </div>
          </div> */}
          {/* <div className="row space-1">
            <div className="col-sm-6">
              <h3 className="space-1">Total Items in Database</h3>
              <h5>{items.length ? items.length : "Fetching details..."}</h5>
            </div>
            <div className="col-sm-6">
              <h3 className="space-1">Today's Revenue and Orders</h3>
              <h5>
                {ordersInDay
                  ? `Orders :  ${ordersInDay.orders} || Revenue : ${ordersInDay.revenue}`
                  : "Fetching details..."}
              </h5>
            </div>
          </div> */}
          {/* <div className="row space-1">
            <div className="col-sm-6">
              <h3 className="space-1">Weekly Revenue and Orders</h3>
              <h5>
                {" "}
                {ordersInWeek
                  ? `Orders :  ${ordersInWeek.orders} || Revenue : ${ordersInWeek.revenue}`
                  : "Fetching details..."}
              </h5>
            </div>
            <div className="col-sm-6">
              <h3 className="space-1">Month's Revenue and Orders</h3>
              <h5>
                {ordersInMonth
                  ? `Orders :  ${ordersInMonth.orders} || Revenue : ${ordersInMonth.revenue}`
                  : "Fetching details..."}
              </h5>
            </div>
          </div> */}
          {/* <div className="row space-3">
            <div className="col-sm-6">
              <h3 className="space-1">Year's Revenue and Orders</h3>

              <h5>
                {" "}
                {ordersInYear
                  ? `Orders :  ${ordersInYear.orders} || Revenue : ${ordersInYear.revenue}`
                  : "Fetching details..."}
              </h5>
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Stats.jsx